export default function() {
    initializeTargetIncentivePlans();
}

function initializeTargetIncentivePlans() {
    let targetIncentivePlansGrids = $('[data-container-for=TargetIncentivePlansList]');
    let targetIncentivePlansHiddenElement = $('[name=TargetIncentivePlans]');

    if (!window.currentPlanConfiguration) {
        return;
    }

    let targetIncentivePlans = window.currentPlanConfiguration.TargetIncentivePlans;

    let incentivizedBy = window.currentPlanConfiguration.IncentivizedBy;

    function init() {
        targetIncentivePlansHiddenElement.ready(function() {
            targetIncentivePlansHiddenElement = $('[name=TargetIncentivePlans]');
        });

        targetIncentivePlans = addMissingIncentivePlans(targetIncentivePlans);
        targetIncentivePlansHiddenElement.val(JSON.stringify(targetIncentivePlans));

        targetIncentivePlansGrids.ready(function() {
            targetIncentivePlansGrids = $('[data-container-for=TargetIncentivePlansList]');
            targetIncentivePlansGrids.parent().html('<div id="tip" class="k-d-grid k-grid-cols-2" style="gap: 20px;"></div>');
            targetIncentivePlansGrids = $('#tip');

            initGrids();
        });
    }

    init();

    function addMissingIncentivePlans(currentIncentivePlans) {
        // Might push these to backend.
        var updatedIncentivePlans = [...currentIncentivePlans];
        if (!currentIncentivePlans.some(ip => ip.TargetIncentivePlanType === 'gross_profit_performance')) {
            updatedIncentivePlans.push({
                TargetIncentivePlanType: 'gross_profit_performance',
                Disabled: true,
                TargetIncentiveRanges: [],
            });
        }

        if (!currentIncentivePlans.some(ip => ip.TargetIncentivePlanType === 'sales_performance')) {
            updatedIncentivePlans.push({
                TargetIncentivePlanType: 'sales_performance',
                Disabled: true,
                TargetIncentiveRanges: [],
            });
        }

        if (!currentIncentivePlans.some(ip => ip.TargetIncentivePlanType === 'cash_management')) {
            updatedIncentivePlans.push({
                TargetIncentivePlanType: 'cash_management',
                Disabled: true,
                TargetIncentiveRanges: [],
            });
        }

        return updatedIncentivePlans;
    }

    function initGrids() {
        targetIncentivePlansGrids.html('');
        createIncentivePlanSection('gross_profit_performance', 'GPP Distribution', true, false, true);
        createIncentivePlanSection('sales_performance', 'Sales Performance Distribution', true, false, true);
        createArOverDaysSection();
        createIncentivePlanSection('cash_management', 'Cash Distribution', false, true, false);
    }

    function createNumericInput(field, value, extraClass) {
        return `
                <span class="numeric-input-wrapper">
                    <input class="target-input ${extraClass}" data-field="${field}" value="${value}" />
                </span>
            `;
    }

    function createArOverDaysSection() {
        const planType = 'cash_management';
        const incentivePlan = targetIncentivePlans.find(ip => ip.TargetIncentivePlanType === planType);

        function onInputChange() {
            const field = $(this).data('field');
            const value = parseFloat($(this).val()) || 0;

            incentivePlan[field] = value;

            targetIncentivePlansHiddenElement.val(JSON.stringify(targetIncentivePlans));
        }

        targetIncentivePlansGrids.append(`<div id="ar-section">
            Average Quarterly A/R over <br/>
            ${createNumericInput('ArOverPercentage', incentivePlan.ArOverPercentage, 'percent')} % over
            ${createNumericInput('ArOverDays', incentivePlan.ArOverDays, 'days')} days.
            </div>`);

        $('#ar-section .target-input.percent').kendoNumericTextBox({
            format: 'n2',
            decimals: 2,
            min: 0,
            max: 999.99,
            spinners: false,
        });

        $('#ar-section .target-input.days').kendoNumericTextBox({
            format: 'n0',
            decimals: 0,
            min: 0,
            max: 3660,
            spinners: false,
        });

        $('#ar-section .numeric-input-wrapper').css({
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            width: '70px',
        });

        // Reattach event listeners
        $('#ar-section .target-input').on('input', onInputChange);
    }

    function createIncentivePlanSection(planType, title, supportXOverY, descending, useWithApproval) {
        targetIncentivePlansGrids.append(`<div id="${planType}-section"></div>`);
        const section = $(`#${planType}-section`);
        section.append(`<h2>${title}</h2>`);
        const xorgreaterId = `${planType}-toprange-xorgreater`;
        const xoveryId = `${planType}-toprange-xovery`;

        if (supportXOverY) {
            section.append(`
                <div style="display: inline">
                    <input type="radio" name="${planType}-toprange-type" id="${xorgreaterId}" class="k-radio" />
                    <label for="${xorgreaterId}" class="k-radio-label">x or greater</label>
                </div>
            `);
            section.append(`
                <div style="display: inline">
                    <input type="radio" name="${planType}-toprange-type" id="${xoveryId}" class="k-radio" />
                    <label for="${xoveryId}" class="k-radio-label">each x over y</label>
                </div>
            `);
        }

        section.append(`<div id="${planType}-grid" class="k-grid"></div>`);

        const grid = $(`#${planType}-grid`);

        const incentivePlan = targetIncentivePlans.find(ip => ip.TargetIncentivePlanType === planType);

        function onInputChange() {
            const parentRow = $(this).closest('tr');
            const rowIndex = parentRow.data('index');
            const field = $(this).data('field');
            const value = parseFloat($(this).val()) || 0;

            if (typeof rowIndex === 'string') {
                incentivePlan[field] = value;
            } else {
                incentivePlan.TargetIncentiveRanges[rowIndex][field] = value;
            }

            targetIncentivePlansHiddenElement.val(JSON.stringify(targetIncentivePlans));
        }

        function updateRadioButtons() {
            if (incentivePlan.GreaterThanIsPercentageStep) {
                $(`#${xoveryId}`).prop('checked', true);
            } else {
                $(`#${xorgreaterId}`).prop('checked', true);
            }
        }

        function onRadioChange() {
            incentivePlan.GreaterThanIsPercentageStep = $(`#${xoveryId}`).is(':checked');
            targetIncentivePlansHiddenElement.val(JSON.stringify(targetIncentivePlans));
            renderGrid();
        }

        function getLessThanIncentiveCell() {
            return useWithApproval
                ? `
                    <td>
                        ${createNumericInput(
                            'LessThanIncentivePercentageWithApproval',
                            incentivePlan.LessThanIncentivePercentageWithApproval
                        )} % w/ approval
                    </td>
                `
                : `
                    <td>
                        ${createNumericInput('LessThanIncentivePercentage', incentivePlan.LessThanIncentivePercentage)} %
                    </td>
                `;
        }

        function getLessThanRow() {
            return `
                <tr data-index="lessThan">
                    <td>
                        Less than 
                        ${createNumericInput('LessThanTargetPercentage', incentivePlan.LessThanTargetPercentage)} %
                    </td>
                    ${getLessThanIncentiveCell()}
                </tr>
            `;
        }

        function getGreaterThanRow() {
            return `
                <tr data-index="greaterThan">
                    <td>
                        ${createNumericInput('GreaterThanTargetPercentage', incentivePlan.GreaterThanTargetPercentage)} % or greater
                    </td>
                    <td>
                        ${createNumericInput('GreaterThanIncentivePercentage', incentivePlan.GreaterThanIncentivePercentage)} %
                        ${
                            incentivePlan.GreaterThanIsPercentageStep
                                ? ` each ${createNumericInput('GreaterThanPercentageStep', incentivePlan.GreaterThanPercentageStep)} % `
                                : ''
                        }
                    </td>
                </tr>
            `;
        }

        function getTargetRangeCell(targetIncentiveRange) {
            return descending
                ? `
                    <td>
                        ${createNumericInput('UpperBoundTargetPercentage', targetIncentiveRange.UpperBoundTargetPercentage)} % to
                        ${createNumericInput('LowerBoundTargetPercentage', targetIncentiveRange.LowerBoundTargetPercentage)} %
                    </td>
                `
                : `
                    <td>
                        ${createNumericInput('LowerBoundTargetPercentage', targetIncentiveRange.LowerBoundTargetPercentage)} % to
                        ${createNumericInput('UpperBoundTargetPercentage', targetIncentiveRange.UpperBoundTargetPercentage)} %
                    </td>
                `;
        }

        function renderGrid() {
            const hasValidationError = window.validationErrors?.some(ve => ve.MemberNames?.some(mn => mn === planType));

            const disabled = planType === 'sales_performance' && incentivizedBy === 'project';

            grid.html(`
                <table class="k-table ${hasValidationError ? 'has-error' : ''}">
                    <thead class="k-grid-header">
                        <tr>
                            <th>Target</th>
                            <th>% ${incentivizedBy === 'project' ? 'project' : 'base salary'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${descending ? getGreaterThanRow() : getLessThanRow()}
                    </tbody>
                </table>
            `);

            const tbody = grid.find('tbody');

            for (let i = 0; i < incentivePlan.TargetIncentiveRanges.length; i++) {
                const targetIncentiveRange = incentivePlan.TargetIncentiveRanges[i];
                tbody.append(`
                    <tr data-index="${i}">
                        ${getTargetRangeCell(targetIncentiveRange)}
                        <td>
                            ${createNumericInput('IncentivePercentage', targetIncentiveRange.IncentivePercentage)} %
                        </td>
                    </tr>
                `);
            }

            tbody.append(descending ? getLessThanRow() : getGreaterThanRow());

            // Buttons for adding/removing rows and toggling enable/disable
            grid.append(`
                <div class="grid-controls" ${disabled ? 'disabled' : ''}>
                    <button id="${planType}-addRow" class="k-button k-primary">Add Range</button>
                    <button id="${planType}-removeRow" class="k-button k-danger">Remove Range</button>
                    <button id="${planType}-toggleDisable" class="k-button">${incentivePlan.Disabled ? 'Disabled' : 'Enabled'}</button>
                </div>
            `);

            // Apply Kendo NumericTextBox to all input fields
            grid.find('.target-input').kendoNumericTextBox({
                format: 'n2',
                decimals: 2,
                min: 0,
                max: 999.99,
                spinners: false,
            });

            grid.find('.target-input').each(function () {
                const inputNumeric = $(this).data('kendoNumericTextBox');

                if (inputNumeric) {
                    inputNumeric.enable(!disabled);
                }
            });

            grid.find('.numeric-input-wrapper').css({
                display: 'inline-flex',
                alignItems: 'center',
                gap: '5px',
                width: '70px',
            });

            // Reattach event listeners
            grid.find('.target-input').on('input', onInputChange);
            $(`#${planType}-addRow`).on('click', addRow);
            $(`#${planType}-removeRow`).on('click', removeRow);
            $(`#${planType}-toggleDisable`).on('click', toggleDisable);

            if (hasValidationError) {
                const validationError = window.validationErrors.find(ve => ve.MemberNames.some(mn => mn === planType));
                grid.append(`<div class="validation-error-message">${validationError.ErrorMessage}</div>`);
            }
        }

        function toggleDisable() {
            incentivePlan.Disabled = !incentivePlan.Disabled;
            targetIncentivePlansHiddenElement.val(JSON.stringify(targetIncentivePlans));
            renderGrid();
        }

        function addRow() {
            incentivePlan.TargetIncentiveRanges.push({
                LowerBoundTargetPercentage: 0,
                UpperBoundTargetPercentage: 0,
                IncentivePercentage: 0,
            });

            targetIncentivePlansHiddenElement.val(JSON.stringify(targetIncentivePlans));
            renderGrid();
        }

        function removeRow(e) {
            e.preventDefault();
            if (incentivePlan.TargetIncentiveRanges.length > 0) {
                incentivePlan.TargetIncentiveRanges.pop();
                targetIncentivePlansHiddenElement.val(JSON.stringify(targetIncentivePlans));
                renderGrid();
            }
        }

        $('#plan-config-incentivized-by').on('change', () => {
            incentivizedBy = $('#plan-config-incentivized-by')
                .data('kendoDropDownList')
                .value();

            if (incentivizedBy === 'project' && planType === 'sales_performance') {
                incentivePlan.Disabled = true;
                incentivePlan.TargetIncentiveRanges = [];
                incentivePlan.GreaterThanTargetPercentage = undefined;
                incentivePlan.GreaterThanIncentivePercentage = undefined;
                incentivePlan.GreaterThanPercentageStep = undefined;
                incentivePlan.LessThanTargetPercentage = undefined;
                incentivePlan.LessThanIncentivePercentageWithApproval = undefined;
                incentivePlan.LessThanIncentivePercentage = undefined;
                targetIncentivePlansHiddenElement.val(JSON.stringify(targetIncentivePlans));
            }

            renderGrid();
            return true;
        });

        if (supportXOverY) {
            $('.k-radio').on('change', onRadioChange);
            updateRadioButtons();
        }

        renderGrid();
    }
}
